export const isDemoUiEnabled = import.meta.env.VITE_DEMO_UI === 'true'

const demoDelayMs = 120

export const demoUiDelay = (): Promise<void> =>
  isDemoUiEnabled ? new Promise((resolve) => setTimeout(resolve, demoDelayMs)) : Promise.resolve()

export async function withDemoUi<T>(demoValue: T, realCall: () => Promise<T>): Promise<T> {
  if (isDemoUiEnabled) {
    await demoUiDelay()
    return demoValue
  }
  return realCall()
}
